import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import RouteLine from '../components/RouteLine';

const crumbs = [
  { label: 'Home', link: '/' },
  { label: 'About Us' },
];

const milestones = [
  { year: 'Phase I', title: 'Shipyard Construction', desc: 'Acquisition of coastal frontiers, establishing high-capacity slipways, workshops, and our core engineering complex.' },
  { year: 'Phase II', title: 'Infrastructure Expansion', desc: 'Strategic investment to complete outfitting quays and a major deep-water 50,000 metric ton dry dock facility.' },
  { year: 'Phase III', title: 'Quality System Integration', desc: 'Achieving comprehensive ISO quality control systems and alignment with strict international safety management standards.' },
  { year: 'Phase IV', title: 'Global Fleet Deployment', desc: 'Expanding capabilities to deliver industrial oil tankers, bulk carriers, and multi-purpose vessels worldwide.' },
];

const team = [
  { name: 'Wei Chen', role: 'Chief Executive Officer', icon: 'fas fa-user-tie' },
  { name: 'Lina Hartono', role: 'Head of Marine Engineering', icon: 'fas fa-drafting-compass' },
  { name: 'Marcus Obi', role: 'Director of ISM & Quality Compliance', icon: 'fas fa-clipboard-check' },
];

export default function About() {
  return (
    <>
      <Breadcrumb title="About Us" crumbs={crumbs} />

      {/* Intro */}
      <section className="section">
        <div className="container">
          <div className="split-grid reveal" style={{ marginBottom: '80px' }}>
            <div>
              <div className="eyebrow"><i className="fas fa-compass"></i> Who We Are</div>
              <h2 className="section-title">Setting the Standard in Maritime Excellence</h2>
              <p>
                East Star Marine is strategically situated to deliver world-class shipbuilding, ship repair, 
                and fleet management services. Driven by a deep understanding of the global shipping market and 
                a commitment to robust maritime infrastructure, we engineer vessels that power global trade.
              </p>
              <p>
                Today we handle technical engineering, heavy shipyard fabrication, dry dock maintenance, and compliance management 
                for fleet operators who require total structural integrity. We pair our cutting-edge machinery with expert 
                oversight to ensure every asset operates seamlessly under rigid conditions.
              </p>
              <Link to="/contact" className="btn btn-primary">Talk to Our Engineering Team <i className="fas fa-arrow-right"></i></Link>
            </div>
            <div>
              <div className="eyebrow"><i className="fas fa-history"></i> Our Strategic Growth</div>
              <h3 className="section-title" style={{ fontSize: '24px' }}>From Infrastructure to Global Fleet Support</h3>
              <div className="timeline">
                {milestones.map((m, i) => (
                  <div key={i} className="timeline-item">
                    <div className="timeline-dot"></div>
                    <h4>{m.year} — {m.title}</h4>
                    <p>{m.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <RouteLine from="SHIPYARD FACILITY" to="GLOBAL EXCELLENCE" light />

          {/* Mission / values */}
          <div className="cards-grid" style={{ marginTop: '60px' }}>
            <div className="service-card reveal">
              <div className="s-icon"><i className="fas fa-bullseye"></i></div>
              <h3>Our Mission</h3>
              <p>To lead the industry with integrity and sustainable practices, merging top-tier facilities with technical expertise to deliver elite bunkering and shipbuilding solutions.</p>
            </div>
            <div className="service-card reveal">
              <div className="s-icon"><i className="fas fa-star"></i></div>
              <h3>Our Vision</h3>
              <p>To establish ourselves as a global leader in maritime operations, crafting innovative engineering answers that resonate with environmental consciousness.</p>
            </div>
            <div className="service-card reveal">
              <div className="s-icon"><i className="fas fa-shield-alt"></i></div>
              <h3>Our Quality Policy</h3>
              <p>Following a customer-centric and market-oriented philosophy, we prioritize continuous improvement, normative management, and absolute safety.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <div className="stats-band">
        <div className="container">
          {[
            ['20', '+', 'Senior Engineers'],
            ['400K', 'T+', 'Annual Shipbuilding Capacity'],
            ['75K', 'T', 'Vessel Capacity Baseline'],
            ['2,000', '+', 'Skilled Specialists'],
          ].map(([num, suffix, label], i) => (
            <div key={i} className="stat-block">
              <strong>{num}<span>{suffix}</span></strong>
              <p>{label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Team
      <section className="section section-alt">
        <div className="container">
          <div style={{ textAlign: 'center', maxWidth: '620px', margin: '0 auto' }}>
            <div className="eyebrow centered"><i className="fas fa-users"></i> Leadership Profile</div>
            <h2 className="section-title centered">The Experts Behind Our Engineering</h2>
          </div>
          <div className="team-grid">
            {team.map((t, i) => (
              <div key={i} className="team-card reveal">
                <div className="team-avatar"><i className={t.icon}></i></div>
                <h4>{t.name}</h4>
                <p>{t.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA */}
      <section className="cta-banner">
        <div className="container">
          <div className="cta-content">
            <div>
              <h3>Ready to Transform Your Maritime Operations?</h3>
              <p>Get a comprehensive technical consultation with our engineering specialists.</p>
            </div>
            <Link to="/contact" className="btn btn-dark">Contact Us <i className="fas fa-arrow-right"></i></Link>
          </div>
        </div>
      </section>
    </>
  );
}